import axios from 'axios'
import config from '@/config.js'
import { decodeJWT } from '@/utilityFunctions'

function createAxiosInstance () {
  const instance = axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout,
    headers: {
      Authorization: config.authToken ? 'JWT ' + config.authToken : null
    }
  })
  return instance
}
const axiosInstance = createAxiosInstance()

axiosInstance.interceptors.response.use(
  response => {
    return response
  }
)

axiosInstance.interceptors.request.use(
  request => {
    request.headers.Authorization = null
    if (!localStorage.getItem('jwt')) return request
    request.headers.Authorization = config.authToken ? 'JWT ' + config.authToken : null
    const jwt = decodeJWT(localStorage.getItem('jwt'))
    if (!jwt.uuid) {
      request.headers.Authorization = null
    }
    const exp = jwt.exp || Date.now
    const diff = Date.now() - exp * 1000
    if (!exp || diff > 0) {
      console.log('current diff: ' + diff)
      alert('session expired')
      localStorage.removeItem('jwt')
      if (window.location.href.indexOf('collectionEntry') !== -1) {
        const splitUrl = window.location.href.split('/')
        window.location.href = config.libraryUrl + '?collectionEntry=' + splitUrl.at(-1)
      }
      location.reload()
    }
    return request
  }, (error) => {
    // Do something with response error
    return Promise.reject(error)
  }
)

export { axiosInstance }
